/**
 * Plan object returned by the API
 */
export class PlanBasicInfo {
    Id: string;
    IwmId: number;
    Identifier: string;
    Name: string;
    Description: string;
    OwnerCompanyId: string;
    OwnerCompanyName: string;
    PlannedStarted: string;
    ActualStarted: string;
    PlannedWorkCompleted: string;
    ActualWorkCompleted: string;
    BudgetLockStateModified?: string;
    BudgetLockStateModifierPersonId?: string;
    BudgetLockStateModifierPersonName?: string;
    BudgetsLocked: boolean;
    Archived: boolean;
    ArchivedTime: string;
    ArchiverPersonId: string;
    ArchiverName: string;
    Subtype: string;
    Priority: string;
    BusinessDomain: string;
    PlanStatus: string;
}

export class PlanComparer {

    public Equals(plan1: PlanBasicInfo, plan2: PlanBasicInfo, propertiesToCompare: string[]): boolean {
        if (!plan1 || !plan2) {
            return false;
        }

        return propertiesToCompare.every(p => plan1[p] === plan2[p]);
    }
}
